export default __webpack_public_path__ + "274070938f4b6bc5f98dd609baf671b4.png";